// extracted by mini-css-extract-plugin
export default {"wrapper":"SlideShow_wrapper__D7Ars"};